import { useMemo } from 'react';

import { isUndefined, mapValues, omit, omitBy } from 'lodash-es';

import { interpolate } from '#src/app/pages/psf/promoteOrShare/shared/utils';

import { useComboCopyVariant } from '../useComboCopyVariant';

import type { TranslationName } from './useCopyI18nKeys';
import { useReplacements } from './useReplacements';

type Result = ModelHookResult<{
	// Resolved override strings from the psf_combo_copy_experiment FCM payload:
	// absence means "use the default copy".
	overrides: Partial<Record<TranslationName, string>>;
}>;

export function useCopyOverrides(): Result {
	const {
		data: { variant },
	} = useComboCopyVariant();
	const {
		data: { replacements },
	} = useReplacements();

	return {
		data: {
			overrides: useMemo((): Partial<Record<TranslationName, string>> => {
				if (!variant) return {};
				// contributionHeroPlural has plural forms: resolved by ComboStory's useContributionHeroCopy
				const resolved = mapValues(
					omit(variant, 'contributionHeroPlural'),
					(element) => element && interpolate(element.value, replacements),
				);
				return omitBy(resolved, isUndefined);
			}, [variant, replacements]),
		},
	};
}
